import { FC, SVGProps } from 'react'
import classNames from 'classnames' // we need this to make JSX compile

type NavLogoType = SVGProps<SVGSVGElement> & {
  size?: number
}

const NavLogo: FC<NavLogoType> = (props) => {
  return (
    <svg
      width={props.size || 44}
      height={props.size || 44}
      viewBox='0 0 44 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M26.444 12.9446L23.2972 17.7964L25.0758 17.9529L17.5508 24.5262L20.424 19.6745H19.1166L20.424 12.9446H14.0288V31.0551H19.8241V27.5659L24.1706 23.7692V31.0551H29.966V12.9446H26.444Z'
        fill='#1D1D1F'
      />
      <path
        d='M37.2752 21.9998C37.2752 13.5622 30.4351 6.72206 21.9974 6.72206C13.5597 6.72206 6.71962 13.5622 6.71962 21.9998C6.71962 30.4375 13.5597 37.2776 21.9974 37.2776V40.3332C11.8722 40.3332 3.66406 32.1251 3.66406 21.9998C3.66406 11.8746 11.8722 3.6665 21.9974 3.6665C32.1226 3.6665 40.3307 11.8746 40.3307 21.9998C40.3307 32.1251 32.1226 40.3332 21.9974 40.3332V37.2776C30.4351 37.2776 37.2752 30.4375 37.2752 21.9998Z'
        fill='#1D1D1F'
      />
    </svg>
  )
}

export default NavLogo
